export function formatMillisecondsAsDuration(milliseconds) {
    if (!Number.isFinite(milliseconds)) {
        return "00:00";
    }

    const totalSeconds = Math.max(0, Math.round(milliseconds / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
        2,
        "0"
    )}`;
}

export function parseDurationToMilliseconds(duration) {
    if (typeof duration === "number" && Number.isFinite(duration)) {
        return duration;
    }

    if (typeof duration !== "string") {
        return null;
    }

    const trimmedDuration = duration.trim();
    const match = trimmedDuration.match(/^(\d+):([0-5]\d)$/);

    if (!match) {
        return null;
    }

    const minutes = Number(match[1]);
    const seconds = Number(match[2]);

    return (minutes * 60 + seconds) * 1000;
}

export function isValidDuration(duration) {
    return parseDurationToMilliseconds(duration) !== null;
}

export function addSecondsToDuration(duration, secondsToAdd) {
    const milliseconds = parseDurationToMilliseconds(duration) ?? 0;
    const nextMilliseconds = Math.max(0, milliseconds + secondsToAdd * 1000);

    return formatMillisecondsAsDuration(nextMilliseconds);
}
